/**
 * Alternate Addresses Legacy Redirect Route
 * Redirects /alternate-addresses/:muns → /alternate-addresses/pc/:muns
 *
 * This provides backward compatibility for links that don't specify the module.
 * Authentication is handled by the parent _protected layout route.
 */
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_protected/alternate-addresses/$muns')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/alternate-addresses/$module/$muns',
      params: {
        module: 'pc',
        muns: params.muns,
      },
    });
  },
});
